import { module as BaseModule } from "modujs"
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { DOMAnimations } from "../utils/dom"

gsap.registerPlugin(ScrollToPlugin)

export default class extends BaseModule {
  init() {
    this.setStates()
    this.createTimeline()
    this.setListeners()
    this.accordeon()
  }

  accordeon() {
    this.toggleAccordeon = this.el.querySelector(
      "[data-navigation-accordeon-toggle]"
    )
    this.accordeon = this.el.querySelector("[data-navigation-accordeon]")
    this.toggleAccordeon.addEventListener("click", () => {
      DOMAnimations.slideToggle(this.accordeon, 300)
    })
  }

  setStates() {
    this.state = false
    this.originalLogo = document.querySelector(".logo")
    this.menuReveal = document.querySelector(".menu-reveal")
    this.menuItems = this.menuReveal.querySelectorAll("li")
    this.logo = this.el.querySelector("[data-navigation-logo]")
    this.toggle = this.el.querySelector("[data-navigation-toggle]")
    this.close = this.el.querySelector("[data-navigation-close]")
    this.burger = this.el.querySelector("[data-navigation-burger]")
    this.wrapper = this.el.querySelector("[data-navigation-wrapper]")
    this.call = this.el.querySelector("[data-navigation-call]")
    this.burgenSpans = this.burger.querySelectorAll("path")
    this.margin = 1.125 * 16
  }

  createTimeline() {
    this.timeline = gsap
      .timeline({ paused: true })
      .add(this.intro(), 0)
      .add(this.menu(), 0)
  }

  intro() {
    const tl = gsap
      .timeline({ paused: false })
      .to(
        this.el,
        {
          duration: 0.5,
          width: () => {
            return window.innerWidth - this.margin * 2
          },
        },
        0
      )
      .set(this.logo, {
        display: "block",
      })
      .to(
        this.el,
        {
          duration: 1,
          height: () => {
            return window.innerHeight - this.margin * 2
          },
        },
        0.2
      )
      .to(this.logo, {
        opacity: 1,
      })
      .to(
        this.toggle,
        {
          padding: () => {
            return this.margin
          },
        },
        0.3
      )
      .to(
        [this.originalLogo, this.burger],
        {
          duration: 0.25,
          autoAlpha: 0,
        },
        0
      )
      .set(this.burger, { autoAlpha: 0 }, 0.25)
      .to(this.close, { autoAlpha: 1 }, 0.25)
      .to(
        this.close,
        {
          rotate: 45,
          duration: 0.25,
        },
        0.5
      )

    return tl
  }

  menu() {
    const tl = gsap
      .timeline()

      .set(
        this.menuReveal,
        {
          display: "grid",
        },
        0.75
      )
      .set(
        this.menuItems,
        {
          opacity: 0,
        },
        0.75
      )
      .set(
        this.call,
        {
          display: "flex",
        },
        0.75
      )
      .to(
        this.menuItems,
        {
          opacity: 1,
          duration: 0.4,
          stagger: 0.1,
        },
        1
      )
      .to(
        this.call,
        {
          opacity: 1,
        },
        1
      )
    return tl
  }

  setListeners() {
    this.toggle.addEventListener("click", this.toggleMenu.bind(this))
  }

  toggleMenu() {
    if (this.state) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  async openMenu() {
    this.state = true

    window.lenis.stop()
    this.timeline.timeScale(1.5)
    this.timeline.play()
    document.body.classList.add("has-menu")
    this.el.setAttribute("aria-expanded", true)
  }

  async closeMenu() {
    this.state = false
    window.lenis.start()
    this.timeline.timeScale(2)
    this.timeline.reverse()
    document.body.classList.remove("has-menu")
    this.el.setAttribute("aria-expanded", false)
  }
}
